import i18nRegister from '../../../../juristec-ui/utils/language/i18nRegister';
import en from './en.json';
import pt from './pt.json';
import es from './es.json';

export default function registerNamespace(path: string) {
  return i18nRegister<keyof typeof pt>(path, { en, pt, es });
}
